import { createAction } from '@reduxjs/toolkit';
import { Locale } from '../types/Locale';

export const setLocale = createAction<Locale, 'SET_LOCALE'>('SET_LOCALE');
